import { render, staticRenderFns } from "./ver_instrumen_komite_sekolah.vue?vue&type=template&id=797b7df2&"
import script from "./ver_instrumen_komite_sekolah.vue?vue&type=script&lang=js&"
export * from "./ver_instrumen_komite_sekolah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports